import { api, type ErrorInfo } from './api';

export interface ErrorReport {
  error: ErrorInfo;
  userAgent: string;
  url: string;
  timestamp: string;
}

export async function reportError(errorInfo: ErrorInfo): Promise<void> {
  const report: ErrorReport = {
    error: errorInfo,
    userAgent: navigator.userAgent,
    url: window.location.href,
    timestamp: new Date().toISOString(),
  };

  try {
    await api.post('/errors/report', report);
  } catch (err) {
    // Silently fail - don't throw error on error reporting
    console.error('Failed to report error:', err);
  }
}
